import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export function mapinit() {
  const maps = document.querySelectorAll('.js-map');

  if (!maps.length) return;

  maps.forEach((mapEl, index) => {
    const lat = mapEl.getAttribute('data-lat');
    const lng = mapEl.getAttribute('data-lng');
    const zoom = mapEl.getAttribute('data-zoom');

    // Ensure each map has a unique ID or use the element directly
    const mapId = mapEl.id || `map-${index}`;
    mapEl.id = mapId;

    const map = L.map(mapId, {
      zoomControl: false,
    }).setView([lat, lng], zoom);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    }).addTo(map);

    const myIcon = L.divIcon({ className: 'map-loc-icon', iconSize: [32, 32] });

    L.marker([lat, lng], { icon: myIcon }).addTo(map);
  });
}